module.exports = __webpack_public_path__ + "web/img/img5.aa57cff9.png";